module.exports = __webpack_public_path__ + "static/media/bockav-ikon-8cb414.16e0cfe0.png";